import BaseView from './BaseView';
import ModuleAnimatedText from '../../classes/ModuleAnimatedText';
import AboutMain from '../../modules/AboutMain';
import AboutServices from '../../modules/AboutServices';
import AboutCulture from '../../modules/AboutCulture';
import AboutAwards from '../../modules/AboutAwards';
import Accordion from "../../classes/Accordion";

let view = null;

class About extends BaseView {
	constructor(container) {
		super(container);
	}

	init() {

		const accordions = this.container.querySelectorAll('[data-accordion]');
		accordions.forEach(accordion => {
			new Accordion(accordion);
		});

		const groups = new Map([
			[ModuleAnimatedText, this.container.querySelectorAll('[data-module-animated-text]')],
			[AboutMain, this.container.querySelectorAll('[data-about-main]')],
			[AboutServices, this.container.querySelectorAll('[data-about-services]')],
			[AboutCulture, this.container.querySelectorAll('[data-about-culture]')],
			[AboutAwards, this.container.querySelectorAll('[data-about-awards]')]
		]);

		super.createModules(groups);
	}
}

export default {
	namespace: 'template-about',
	beforeEnter: ({ current, next, trigger }) => {
		view = new About(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
